import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { IPedido } from '@mobile/models/pedido/pedido.model';
import { StatusPedidoEnum } from '@mobile/models/status-pedido.enum';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PedidosFirebaseService {
  constructor(private afs: AngularFirestore) {}

  watchPedido(id: string): Observable<IPedido | undefined> {
    return this.afs
      .collection('Pedidos')
      .doc(id)
      .snapshotChanges()
      .pipe(map(changes => changes.payload.data() as IPedido | undefined));
  }

  async getPedido(id: string): Promise<IPedido | undefined> {
    const doc = await this.afs.firestore.collection('Pedidos').doc(id).get();
    return doc.data() as IPedido | undefined;
  }

  postPedido(pedido: { id: string } & Record<string, unknown>): Promise<void> {
    return this.afs.collection('Pedidos').doc(pedido.id).set(pedido);
  }

  /** Últimos 5 pedidos entregues do usuário, do mais recente para o mais antigo. */
  async getUltimosPedidos(uid: string): Promise<(Omit<IPedido, 'criadoEm'> & { criadoEm: Date })[]> {
    const snapshot = await this.afs.firestore
      .collection('Pedidos')
      .orderBy('criadoEm')
      .where('user_id', '==', uid)
      .where('status', '==', StatusPedidoEnum.ENTREGUE)
      .limitToLast(5)
      .get();

    return snapshot.docs
      .map(d => {
        const data = d.data();
        return { ...data, criadoEm: data.criadoEm.toDate() } as Omit<IPedido, 'criadoEm'> & { criadoEm: Date };
      })
      .sort((a, b) => b.criadoEm.getTime() - a.criadoEm.getTime());
  }
}
